import isEmpty from 'lodash/isEmpty';

import { VARIANTS } from '@jobcase/react_pattern_library/components/Toaster/Toaster';

import entity from './entity';

import { setNotification } from '../../notification/actions';

const TYPES = {
  CLEAR_STATE: 'campaignAnalytics/CLEAR_STATE',
  GET_TABLEAU_AUTH_REQUEST: 'campaignAnalytics/GET_TABLEAU_AUTH_REQUEST',
  GET_TABLEAU_AUTH_SUCCESS: 'campaignAnalytics/GET_TABLEAU_AUTH_SUCCESS',
  GET_TABLEAU_AUTH_FAILURE: 'campaignAnalytics/GET_TABLEAU_AUTH_FAILURE',
};

export const getTableauTicket = orgId => async (dispatch) => {
  dispatch({ type: TYPES.GET_TABLEAU_AUTH_REQUEST });
  try {
    const token = await entity.api.fetchTableauTicket(orgId);
    dispatch({ type: TYPES.GET_TABLEAU_AUTH_SUCCESS, payload: token });
    return token;
  } catch (error) {
    dispatch({ type: TYPES.GET_TABLEAU_AUTH_FAILURE, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while loading campaign analytics ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading campaign analytics.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const clearState = () => (dispatch) => {
  dispatch({ type: TYPES.CLEAR_STATE });
};

export {
  TYPES,
};

export default {
  TYPES,
  clearState,
  getTableauTicket,
};
